import React, { lazy, Suspense } from 'react'
import getMovieTitle from '../functions/getMovieTitle';
import { MOVIE } from '../constants/itemTypes';

const StripeItem = lazy(() => import('./StripeItem'));


export const PosterFormatItemLoading = ({
    title
}) => (
    <div className="poster-format-item-wrapper">
        <div className="poster-format-item">
            <div className="picture-wrapper theme-radius-posters-top"></div>
        
            
            <div className="horizontal-flex-wrapper theme-radius-posters-bottom">
                <div className="performance-items-wrapper theme-radius-posters-bottom">
                    <div className="performance-item-dates-wrapper">
                        <div className="performance-item-wrapper">
                            {title && <div className="performance-item-date text-medium">{title}</div>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
)

export const BackgroundFormatItemLoading = ({
    title
}) => (
    <div className="poster-format-item-wrapper background-version">
        <div className="poster-format-item">
            <div classNAme="picture-wrapper theme-radius-posters-top"></div>
                <div className="image"></div>
                {title && <div className="text-xlarge-bold movie-title">{title}</div>}
        </div>
    </div>
)

const StripeItemLoading = ({
    title
}) => (
    <div className="slide-item">
        <PosterFormatItemLoading
            title={title}
        />
    </div>
)

const StripeItemLoadingArthouse = ({
    title
}) => (
    <div className="order-wrapper slide-item">
        <BackgroundFormatItemLoading
            title={title}
        />
    </div>
)



const StripeItemLazy = (props) => {
    if(!props.item) {
        return ''
    }

    const { id, type } = props.item
    let itemData
    let currentTitle = ''

    if(MOVIE === type && props.moviesData.hasOwnProperty(id)) {
        itemData = props.moviesData[id]
        currentTitle = getMovieTitle(itemData)
    } else {
        return ''
    }

    const ItemLoading = props.theme === 'Arthouse' ? StripeItemLoadingArthouse : StripeItemLoading

    return (        
        <Suspense fallback={<ItemLoading title={currentTitle}/>}>
            <StripeItem
                itemData={itemData}
                {...props}
            />
        </Suspense>
    )
}

export default StripeItemLazy